module.exports = __webpack_public_path__ + "static/img/2s-info-b7.ba2a071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-info-b7.jpg
// module id = Z8Yx
// module chunks = 0